import React, {useEffect, useRef} from "react";
import {DetailsStateReturn} from "./useDetailsState.tsx";

/**
 * `details` element with observer bound to the `open` attribute.
 */
export const Details: React.FC<
    React.HTMLAttributes<HTMLDetailsElement> & DetailsStateReturn
> = ({setOpen, ...props}) => {
    const detailsEl = useRef<HTMLDetailsElement>(null);

    // Listen for changed to the `open` attribute, calling `setOpen` when it changes.
    useEffect(() => {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.attributeName === "open") {
                    setOpen(detailsEl.current!.open);
                }
            }
        });

        observer.observe(detailsEl.current!, {
            attributes: true,
            childList: false,
            subtree: false,
            attributeFilter: ["open"]
        });

        return () => observer.disconnect();
    }, [setOpen]);

    return <details ref={detailsEl} {...props} />;
};
